import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SubHeaderService } from '../../../store/subheader/subheader.service';
import { Action, ActionMode } from '../../../store/view/types';
import { buildActionRouterLink } from '../../../helper/viewhelper';

@Component({
  selector: 'app-action-link',
  templateUrl: './action-link.component.html',
  styleUrl: './action-link.component.scss',
  standalone: false,
})
export class ActionLinkComponent implements ICellRendererAngularComp {
  data: any;
  actions: Action[];
  resolvedActions: { action: Action; routerLink: any[] }[] = [];
  params!: ICellRendererParams;
  componentParent: any;

  protected readonly ActionMode = ActionMode;

  constructor(private readonly subHeaderService: SubHeaderService) {}

  agInit(params: ICellRendererParams): void {
    this.data = params.data;
    this.actions = params.value;
    // Resolved once per row: a method binding in the template would hand RouterLink a new array
    // on every change detection cycle.
    this.resolvedActions = (this.actions ?? []).map((action) => ({
      action,
      routerLink: buildActionRouterLink(action, this.data),
    }));

    this.componentParent = params.context.componentParent;
  }

  refresh(params: ICellRendererParams) {
    this.params = params;
    return true;
  }

  triggerAction(actionName: string) {
    try {
      this.componentParent.setRowData(this.data);
    } catch (err) {
      console.error(err);
    }
    this.subHeaderService.setTriggerAction(actionName);
  }
}
